import { Popover } from 'antd';
import { useState, useMemo } from 'react';
import { MyAccessibleDoctor } from '../../../bridge/types/doctorProfile';
import useFuseSearch from '../../../hooks/use-fuse-search';
import { AP } from '../../../pages/types/appointments';
import TooltipComponent from '../../common/TooltipComponent';
import BarsRegularIcon from '../../icons/bars-regular';
import DoctorSearch from './DoctorSearch';
import DoctorFilterStripUi from './FilterStripUi';
import React from 'react';

const DoctorsList = ({
    doctorsList,
    selectedDoctor,
    onSelectDoctorClick,
    showDoctorAptCount = false,
    appointments,
}: {
    doctorsList: MyAccessibleDoctor[];
    selectedDoctor: MyAccessibleDoctor | undefined;
    onSelectDoctorClick: (doctor: MyAccessibleDoctor | undefined) => void;
    showDoctorAptCount?: boolean;
    appointments: AP[];
}): JSX.Element => {
    const [openDoctorSearch, setOpenDoctorSearch] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState<string>('');

    //   const selectedDoctor = useFrontDeskStore((state) => state.selectedDoctor);

    const searchDoctorFilterList =
        useFuseSearch(inputValue, doctorsList || [], ['name', 'username']) || [];
    const doctorStrips = useMemo(
        () =>
            doctorsList?.map((doctor) => (
                <DoctorFilterStripUi
                    key={doctor.id}
                    doctorName={`Dr. ${doctor.personal.name.f || ''} ${
                        doctor.personal.name.l || ''
                    }`.trim()}
                    doctorPic={
                        doctor.personal.pic ||
                        'https://cdn.eka.care/vagus/cl2rhhut3000l0sg1fkcghr9j.png'
                    }
                    aptCount={
                        appointments?.filter((apt) => apt.doctor_oid === doctor.id).length || 0
                    }
                    isSelected={selectedDoctor?.id === doctor.id}
                    onClick={() => onSelectDoctorClick(doctor)}
                    showAptCount={showDoctorAptCount}
                />
            )),
        [doctorsList, appointments, selectedDoctor?.id, showDoctorAptCount, onSelectDoctorClick],
    );
    return (
        <>
            {doctorStrips}
            {(doctorStrips || [])?.length > 3 ? (
                <div className="dr-sticky dr-right-0 dr-top-0 dr-bg-darwin-neutral-0">
                    <Popover
                        style={{ borderRadius: '1rem' }}
                        placement="bottomRight"
                        trigger={['click']}
                        destroyTooltipOnHide
                        visible={openDoctorSearch}
                        onVisibleChange={(value) => setOpenDoctorSearch(value)}
                        content={
                            <DoctorSearch
                                list={searchDoctorFilterList}
                                inputValue={inputValue}
                                setInputValue={setInputValue}
                                setSelectedDoctor={onSelectDoctorClick}
                                selectedDoctor={selectedDoctor}
                            />
                        }
                        overlayClassName="fd-popup"
                    >
                        <div>
                            <TooltipComponent
                                arrowPointAtCenter={true}
                                placement="top"
                                title={'Doctors List'}
                            >
                                <div className="dr-p-6 dr-cursor-pointer dr-rounded-8 dr-border-1 dr-border-darwin-neutral-200 hover:dr-border-darwin-primary-primary hover:dr-bg-darwin-primary-bg-light dr-bg-darwin-neutral-0">
                                    <BarsRegularIcon className="dr-p-2 dr-w-24 dr-h-24 dr-text-darwin-neutral-600" />
                                </div>
                            </TooltipComponent>
                        </div>
                    </Popover>
                </div>
            ) : null}
        </>
    );
};

export default DoctorsList;
